import { QueryCache, QueryClient } from '@tanstack/react-query';

export const createQueryClient = () => {
	return new QueryClient({
		queryCache: new QueryCache({
			onError: (error: any) => {
				// Log errors to console because the query client swallows errors
				if (error.name === 'ZodError') {
					console.error('Zod Validation Error Details:', error);
				} else {
					console.error('React Query Error:', {
						message: error.message,
						stack: error.stack,
						name: error.name,
					});
				}
			},
		}),
		defaultOptions: {
			queries: {
				// This needs to be higher than the persistence maxAge otherwise it will just remove the
				// stored data as soon as it's loaded
				cacheTime: 48 * 60 * 60 * 1000,
				keepPreviousData: true,
				retry: false,
				staleTime: 10 * 60 * 1000,
			},
		},
	});
};
